<div class="container">
    <div class="title">{{serviceRequest.action}}</div>
    <div class="number">{{(serviceRequest.timestamp + 'Z').replace(' ', 'T') | date: 'medium'}}</div>
    <div class="label">{{serviceRequest.name}}</div>
    <div class="log">{{serviceRequest.description}}</div> 
</div>
